<mat-spinner color="primary" *ngIf="!error; else errorTmp"></mat-spinner>
<ng-template #errorTmp>
  <p translate>errors.invalid-code</p>
</ng-template>
